import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { api, fmtUsd } from "@/lib/api";

const label = (m) => new Date(`${m}-01T00:00:00Z`).toLocaleDateString("en-US", { month: "short", year: "numeric", timeZone: "UTC" });
const COLORS = { buy: "#10B981", sell: "#EF4444", withdraw: "#F7931A" };

export const FeeReport = ({ reloadKey }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/fee-report").then((r) => setRows(r.data)).catch(() => setRows([])); }, [reloadKey]);
  const chart = (rows || []).slice(0, 12).reverse().map((r) => ({ ...r, name: label(r.month) }));
  const total = (rows || []).reduce((s, r) => s + r.total, 0);

  return (
    <section className="card p-5 md:p-6" data-testid="admin-fee-report">
      <div className="mb-4 flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="text-lg font-semibold tracking-tight">Monthly fee report</h3>
        <p className="text-sm text-[#94A3B8]">All-time fees: <span className="font-mono font-semibold text-[#F7931A]" data-testid="fee-report-total">{fmtUsd(total)}</span></p>
      </div>
      {!rows ? <p className="py-6 text-center text-xs text-[#64748B]">Loading...</p> : rows.length === 0 ? (
        <p className="py-6 text-center text-sm text-[#64748B]" data-testid="fee-report-empty">No fees collected yet.</p>
      ) : (
        <>
          <div style={{ height: 220 }} data-testid="fee-report-chart">
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={chart} margin={{ top: 4, right: 0, bottom: 0, left: 0 }}>
                <XAxis dataKey="name" tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} />
                <YAxis tick={{ fill: "#64748B", fontSize: 11 }} axisLine={false} tickLine={false} width={50} tickFormatter={(v) => `$${v}`} />
                <Tooltip cursor={{ fill: "#1C2030" }} contentStyle={{ background: "#151824", border: "1px solid #212638", borderRadius: 12 }} formatter={(v, n) => [fmtUsd(v), n]} />
                {Object.entries(COLORS).map(([k, c]) => <Bar key={k} dataKey={k} stackId="f" fill={c} isAnimationActive={false} />)}
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs uppercase tracking-[0.15em] text-[#64748B]">
                <th className="pb-3">Month</th><th className="pb-3">Buys</th><th className="pb-3">Sells</th><th className="pb-3">Withdrawals</th>
                <th className="pb-3">Total fees</th><th className="hidden pb-3 md:table-cell">Transactions</th><th className="hidden pb-3 md:table-cell">Volume</th>
              </tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.month} className="border-t border-[#212638] font-mono" data-testid={`fee-report-row-${r.month}`}>
                    <td className="py-3 font-sans font-semibold">{label(r.month)}</td>
                    <td className="py-3 text-emerald-400">{fmtUsd(r.buy)}</td>
                    <td className="py-3 text-red-400">{fmtUsd(r.sell)}</td>
                    <td className="py-3 text-[#F7931A]">{fmtUsd(r.withdraw)}</td>
                    <td className="py-3 font-semibold" data-testid={`fee-report-total-${r.month}`}>{fmtUsd(r.total)}</td>
                    <td className="hidden py-3 md:table-cell">{r.count}</td>
                    <td className="hidden py-3 md:table-cell">{fmtUsd(r.volume)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
};
